import React, { Component } from "react";
import Navbar from "../Navbars/Navbar";
import Footer from "components/Footers/Footer";
import "assets/css/safexpay-web.css";
import "../Policy/Policy.css";

class RegulatoryDisclosures extends Component {
  righthandler = () => {
    document.addEventListener('contextmenu', event => event.preventDefault());
    }
    
    componentDidMount() {
      this.righthandler();
    }
  render() {
    return (
      <>
        <Navbar />
        <main ref="main" className="dv-main">
          <section
            className="dv-HeroBanner dv-Policy"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <h1 className="herobanner-heading text-center pt-5 font-w6">
              Regulatory Disclosures
            </h1>
          </section>
          <section className="dv-Policy-content">
            <div
              className="container"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <div className="row">
                <div
                  className="col-12"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <a
                    href="/Annual Return 2020-21-Paygate-Website.pdf"
                    target="_blank"
                    className="link-tag"
                  >
                    <h5>Annual Return-F.Y 2020-21</h5>
                  </a>
                  <a
                    href="/CSR Policy -Paygate India.pdf"
                    target="_blank"
                    className="link-tag"
                  >
                    <h5>CSR Policy</h5>
                  </a>
                  <a
                    href="/POSH Policy.pdf"
                    target="_blank"
                    className="link-tag"
                  >
                    <h5>POSH Policy</h5>
                  </a>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </>
    );
  }
}

export default RegulatoryDisclosures;
